
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({ components: {} })
export default class Popup extends Vue {
  @Prop() hideFooter: boolean | undefined;
  @Prop() hideHeader: boolean | undefined;
  @Prop() isVisible!: boolean;
  @Prop() hideClose!: boolean | undefined;
  @Prop() private onEnter?: () => void;
  @Prop() private init?: () => void;
  @Prop({ default: 'center' }) popupPosition!: 'center' | 'bottom-right-corner';

  private keyUpListener: (e: KeyboardEvent) => void = this.onKeyUp;

  @Watch('isVisible')
  private onPopupVisibilityChange(isVisibleCurrently: boolean, isVisiblePrevious: boolean) {
    if (isVisibleCurrently !== isVisiblePrevious) {
      if (isVisibleCurrently) {
        window.addEventListener('keyup', this.keyUpListener);
        if (this.init) {
          this.init();
        }
      } else {
        window.removeEventListener('keyup', this.keyUpListener);
      }
    }
  }

  get containerStyle() {
    return { 'zawa-popup__container': true, 'bottom-right-corner': this.popupPosition === 'bottom-right-corner' };
  }

  mounted(): void {
    if (this.isVisible) {
      window.addEventListener('keyup', this.keyUpListener);
    }
    this.$nextTick(() => {
      (this.$refs.popupWrap as HTMLElement).focus();
    });
  }
  beforeDestroy() {
    window.removeEventListener('keyup', this.keyUpListener);
  }
  private onKeyUp(e: KeyboardEvent): void {
    e.preventDefault();
    const key = e.key || e.keyCode;
    if (key === 13 || key === 'Enter') {
      if (this.onEnter) {
        this.onEnter();
      }
    } else if (key === 'Escape') {
      this.close();
    }
  }
  @Emit()
  close(): void {}
}
